package com.example.mystybag.sharedmodels.common.responseModels

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
class GetCountriesResponseModel(
    @SerialName("countries_list")
    val countriesList: List<CountryModel>? = null
): BaseResponseModel()

@Serializable
data class CountryModel(
    var id              : Int        = 0,
    @SerialName("iso_alpha_2")
    var isoAlpha2       : String     = "",
    @SerialName("iso_alpha_3")
    var isoAlpha3       : String     = "",
    @SerialName("iso_numeric")
    var isoNumeric      : String     = "",
    @SerialName("name")
    var name            : String     = "",
    @SerialName("dial_code")
    var dialCode        : String     = "",
    @SerialName("default_currency")
    var defaultCurrency : String     = "",
    var localCurrency   : String     = "",
    var isSelected      : Boolean    = false
)